import React from 'react';
import * as Yup from 'yup';

import { ApplicationFlow } from '../components';
import { documentTypes } from '../data';

const Description = () => (
  <React.Fragment>
    <p>
      A personal service corporation is a corporation that is created for the purpose of providing personal services to individuals or groups. Such services span a wide variety of professional business endeavors as specified by the Internal Revenue Service (IRS)
    </p>
  </React.Fragment>
);


const fieldSets = [
  {
    legend: 'Personal Service Corporation Information',
    fields: new Map([
      ['orgName', {
        label: 'Corporation Name',
        title: 'Please provide a valid corporation name',
        'data-help-title': 'Corporation Name',
        'data-help-text': 'Please enter the name of the corporation.',
        validation: Yup.string().required('Please provide a valid corporation name'),
      }],
      ['dba', {
        'data-help-text': 'Please enter the trade name of the corporation.',
      }],
    ]),
  },
  {
    legend: 'Primary Officer Information',
    fields: new Map([
      ['firstName', {
        'data-help-title': 'Principal Officer',
        'data-help-text': 'Principal/Highest ranking officer.',
      }],
      ['middleName', {
        'data-help-title': 'Principal Officer',
        'data-help-text': 'Principal/Highest ranking officer.',
      }],
      ['lastName', {
        'data-help-title': 'Principal Officer',
        'data-help-text': 'Principal/Highest ranking officer.',
      }],
      ['socialSecurity', {
        'data-help-title': 'Principal Officer',
        'data-help-text': 'Principal/Highest ranking officer.',
      }],
      ['verifySocialSecurity', {
        'data-help-title': 'Principal Officer',
        'data-help-text': 'Principal/Highest ranking officer.',
      }],
      ['title', {
        label: "Officer's Title",
        placeholder: 'Mangaing Member',
        'data-help-title': 'Mangaing Member',
        'data-help-text': 'Principal/Highest ranking officer.',
      }],
      ['suffix', {
        initial: 'DDS',
      }],
    ]),
  },
  {
    legend: 'Business Address (No PO Boxes)',
    fields: new Map([
      ['businessAddress'],
      ['businessCity'],
      ['businessState'],
      ['businessZip'],
      ['businessCounty'],
      ['mailingAddressDiff'],
    ]),
  },
  {
    legend: 'Business Information',
    fields: new Map([
      ['businessIncCountry'],
      ['businessApplyReason'],
      ['businessActivity'],
      ['businessServices'],
      ['commonQuestionOne'],
      ['commonQuestionTwo'],
      ['commonQuestionThree'],
      ['commonQuestionFour'],
      ['businessAppliedBefore'],
      ['businessHireEmployees'],
    ]),
  },
  {
    legend: 'Business Dates',
    fields: new Map([
      ['businessDateStart'],
      ['businessClosingMonth'],
    ]),
  },
  {
    legend: 'Contact Information',
    fields: new Map([
      ['customerContactPhone'],
      ['customerContactEmail'],
      ['customerContactEmailVerify',{
        label: 'Verify Contact E-mail'
      }],
    ]),
  },
];


const PersonalServiceApplicationPage = props => (
  <ApplicationFlow
    step={2}
    title="Personal Service Corporation Application"
    documentType={documentTypes.PERSONAL_SERVICE_CORPORATION}
    description={Description}
    fieldSets={fieldSets}
    {...props}
  />
);

export default PersonalServiceApplicationPage;



// WEBPACK FOOTER //
// ./src/pages/personal-service-application.js